import classNames from 'classnames'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { PhoneCall } from 'legacy/lut/components/shared/PhoneCall'
import React from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Grid, Item } from 'core-components/library/grid'

import styles from '../ContactTileCell.module.scss'

import RenderCardHead from './RenderCardHead'
import { renderCardStatusLine } from './tileBlocksMethods'

export default function phoneBlock(item: DataModel | IForm) {
  const partnerId = item.get('PartnerID')

  return (
    <Grid wrap={'nowrap'}>
      <Item xs={'auto'}>{renderCardStatusLine(item)}</Item>
      <Item xs={true}>
        <Grid wrap={'nowrap'}>
          <Item xs={'auto'}>
            <span className={classNames(styles.dataIcon, 'hpicon hpicon-telephone2')} />
          </Item>
          <Item xs={true}>
            {item.get('FirstName') || item.get('LastName') ? (
              <div className={styles.profileName}>
                <span className={styles.profileName__item}>
                  {item.get('Salutation')} {item.get('FirstName')}
                </span>
                <span className={styles.profileName__item}>{item.get('LastName')}</span>
              </div>
            ) : null}
            <p className={styles.data}>
              <span className={styles.data__label}>Never Call:</span>
              <span className={styles.data__value}>{item.get('NeverCall')}</span>
            </p>
            {(item.get('WorkPhone') || '').length ? (
              <p className={styles.data}>
                <span className={styles.data__label}>Work Phone:</span>
                <PhoneCall
                  className={styles.data__value}
                  value={`${item.get('WorkPhone_Prefix') || ''}${item.get('WorkPhone') || ''}`}
                  isContactLevel={!!item.get('HPD_Contact_GUID')}
                  guid={item.get('HPD_Contact_GUID') || item.get('HPD_Partner_GUID')}
                  partnerId={partnerId}
                />
              </p>
            ) : null}
            {(item.get('MobilePhone') || '').length ? (
              <p className={styles.data}>
                <span className={styles.data__label}>Mobile Phone:</span>
                <PhoneCall
                  className={styles.data__value}
                  value={`${item.get('MobilePhone_Prefix') || ''}${item.get('MobilePhone') || ''}`}
                  isContactLevel={!!item.get('HPD_Contact_GUID')}
                  guid={item.get('HPD_Contact_GUID') || item.get('HPD_Partner_GUID')}
                  partnerId={partnerId}
                />
              </p>
            ) : null}
            {(item.get('MainPhone') || '').length ? (
              <p className={styles.data}>
                <span className={styles.data__label}>Main Phone:</span>
                <PhoneCall
                  className={styles.data__value}
                  value={item.get('MainPhone')}
                  isContactLevel={!!item.get('HPD_Contact_GUID')}
                  guid={item.get('HPD_Contact_GUID') || item.get('HPD_Partner_GUID')}
                  partnerId={partnerId}
                />
              </p>
            ) : null}
          </Item>
        </Grid>
        <Grid wrap={'nowrap'}>
          <Item xs={'auto'}>
            <span className={`kbase kbase-send ${styles.dataIcon}`} />
          </Item>
          <Item xs={true}>
            <p className={styles.data}>
              <span className={styles.data__label}>Never Email:</span>
              <span className={styles.data__value}>{item.get('NeverEmail')}</span>
            </p>
            <p className={styles.data}>
              <span className={styles.data__label}>Email:</span>
              <span className={styles.data__value}>{item.get('Email')}</span>
            </p>
            <p className={styles.data}>
              <span className={styles.data__label}>Email Generic:</span>
              <span className={styles.data__value}>{item.get('EmailCompany')}</span>
            </p>
          </Item>
        </Grid>
      </Item>
      <Item xs={'auto'}>
        <RenderCardHead item={item} />
      </Item>
    </Grid>
  )
}
